import React, { useState, useEffect } from 'react';

import './styles.css';

import callListServices from '../../../../services/academy/callListServices';

import { months } from '../../../../functions/formatDate';
import compare from '../../../../functions/compare';

import ClassCallListsCardItem from './ClassCallListsCardItem';
import PopupNewCallList from './PopupNewCallList';
import PopupCallList from './PopupCallList';
import { FaClipboardList } from 'react-icons/fa';
import ActivityIndicator from '../../../../components/ActivityIndicator';

import reportServices from '../../../../services/reportServices';

export default function ClassCallListsCard(props) {
    const [popupNewCallListVisible, setPopupNewCallListVisible] = useState(false);
    const [popupCallListVisible, setPopupCallListVisible] = useState(false);
    const [popupCallListData, setPopupCallListData] = useState(null);
    const [callLists, setCallLists] = useState([]);
    const [numShowed, setNumShowed] = useState(3);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (props.classId)
            readCallLists();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.classId]);

    async function readCallLists() {
        const response = await callListServices.getCallLists(props.classId);
        setFetching(false);
        if (response.status === 200) {
            setCallLists(response.data.sort((a, b) => compare(a.data + a.hora, b.data + b.hora, true)));
        } else
            alert("Erro ao ler listas de chamada, tente novamente!");
    }

    function showModeCallLists() {
        if (numShowed + 3 >= callLists.length)
            setNumShowed(callLists.length);
        else
            setNumShowed(numShowed + 3);
    }

    return (
        <div className='class-page-card' id='card-call-lists'>
            <div className='class-card-call-lists-header'>
                <h4><b>
                    <FaClipboardList />
                    {props.studentProfileMode ? "Presenças" : "Listas de chamada"}
                </b></h4>
            </div>

            {
                props.studentProfileMode ?
                    [] :
                    <>
                        <button className='new-call-list' onClick={() => setPopupNewCallListVisible(true)}>Registrar chamada</button>
                        <PopupNewCallList
                            visibility={popupNewCallListVisible}
                            setVisibility={setPopupNewCallListVisible}
                            classId={props.classId}
                            classStudents={props.classStudents}
                            onCreate={readCallLists}
                        />
                    </>
            }

            {
                !fetching ?
                    <>
                        <div className='class-card-call-lists-list-infos'>
                            <p><b>Histórico</b></p>
                            <p>{callLists.length} registros</p>
                        </div>
                        {
                            callLists.length ?
                                <>
                                    <ul className='class-card-call-lists-list'>
                                        {
                                            callLists.slice(0, numShowed).map((item, index) => {
                                                const date = item.data.split('-').reverse();
                                                return <ClassCallListsCardItem
                                                    key={item.id}
                                                    studentProfileMode={props.studentProfileMode}
                                                    dateTime={`${date[0]} de ${months[Number(date[1]) - 1]} de ${date[2]} às ${item.hora.slice(0, 5)}`}
                                                    type={item.atividade}
                                                    class={item.turma ? item.turma.nome : null}
                                                    studentsCount={item.alunos ? item.alunos.length : 0}
                                                    present={item.presenca ? item.presenca.check_in : false}
                                                    generateReport = {() => {
                                                        const fileName = prompt('Nome do Documento:');
                                                        if(fileName) {
                                                            const data = item.data + " " +item.hora;
                                                            const dataObj = new Date(data.replace(/-/g, '/'));
                                                            let timeString = item.hora.split(":");
                                                            timeString = timeString[0] + ":" +timeString[1];
                                                            reportServices.generateReportCallLists(item.alunos, `Lista de chamada da turma "${item.turma.nome}" no dia ${dataObj.toLocaleDateString()} às ${timeString}`, fileName);
                                                        }
                                                    }}
                                                    showPopup={() => {
                                                        setPopupCallListData(item);
                                                        setPopupCallListVisible(true);
                                                    }}
                                                />
                                            })
                                        }
                                    </ul>
                                    {
                                        numShowed < callLists.length ?
                                            <button className='show-more' onClick={showModeCallLists}>Exibir mais</button>
                                            : []
                                    }
                                </>
                                : []
                        }

                        <PopupCallList
                            data={popupCallListData}
                            visibility={popupCallListVisible}
                            setVisibility={setPopupCallListVisible}
                            onUpdate={readCallLists}
                        />
                    </>
                    : <ActivityIndicator />
            }
        </div>
    )
}